var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "quote-container" }, [
    _c(
      "div",
      { staticClass: "quote-header" },
      [
        _c(
          "a",
          { attrs: { href: "/" } },
          [
            _c("rt-picture", {
              attrs: {
                src: "/assets/app/signup/icon-logo.svg",
                autosize: false,
              },
            }),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "primary-button",
          { staticClass: "btn-normal btn-back", on: { click: _vm.moveBack } },
          [_vm._v("\n      Back\n    ")]
        ),
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "page-content" },
      [
        !_vm.isRequestSucceed
          ? _c("QuoteForm", {
              attrs: {
                username: _vm.userName,
                email: _vm.userEmail,
                schoolName: _vm.schoolName,
              },
              on: {
                onSuccess: function ($event) {
                  _vm.isRequestSucceed = true
                },
              },
            })
          : _c("QuoteSuccessView", { on: { onClose: _vm.moveBack } }),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }